<template>
	<view class="bill-of-lading-details">
		<view class="driver" style="background:url(../../../static/image/coalBackgroud/coal-background.png) no-repeat;background-size:100% 100%;">
			<view class="driver-coalOne">电子提煤单</view>
			<view class="driver-coalTwo">
				<view class="">东庞矿北井</view>
				<view class="">1/3焦</view>
				<view class="">冀A37U98</view>
			</view>
			<view class="driver-coalThree">
				<view class="">旭阳焦化有限责任公司</view>
				<view class="">2022年8月28日 15:00:56</view>
			</view>
			<view class="driver-coalFour"><image src="@/static/logo.gif" mode=""></image></view>
		</view>
	</view>
</template>

<script>
export default {
	onLoad(value) {
		console.log('页面加载', value);
		if (value.orderPlanId) {
			this.orderPlanId = value.orderPlanId;
		}
	},
	data() {
		return {
			orderPlanId: null
		};
	},
	onShow() {
		this.init();
	},
	methods: {
		init() {
			this.getTakeCoal();
		},
		// 获取提煤单详情
		getTakeCoal() {
			this.$reqGet('getTakeCoal', { takeCoalId: this.orderPlanId }).then(res => {
				console.log('获取提煤单详情', res);
			});
		}
		/**
		 * @desc 等待取煤单接口
		 * */
	}
};
</script>

<style lang="scss" scoped>
::v-deep.bill-of-lading-details {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;

	// 司机页面
	.driver {
		width: 100%;
		height: 100vh;
		&-coalOne {
			margin-top: 19%;
			text-align: center;
			font-size: vww(40);
			font-family: Source Han Sans CN, Source Han Sans CN-Bold;
			font-weight: 700;
			color: #896227;
		}
		&-coalTwo {
			margin-top: 20%;
			font-size: vww(20);
			font-family: Source Han Sans CN, Source Han Sans CN-Bold;
			font-weight: 700;
			text-align: center;
			color: #2e363f;
			view:nth-child(2) {
				margin-top: vww(15);
			}
			view:nth-child(3) {
				margin-top: vww(15);
			}
		}
		&-coalThree {
			margin-top: vww(76);
			font-size: vww(18);
			font-family: Source Han Sans CN, Source Han Sans CN-Bold;
			font-weight: 700;
			text-align: center;
			color: #2e363f;
			view:nth-child(2) {
				margin-top: vww(8);
			}
		}
		&-coalFour {
			margin: vww(68) 0 0 45.5%;
			image {
				width: vww(35);
				height: vww(35);
			}
		}
	}
}
</style>
